export {Logo} from './lib/logo';